import React from "react";

const HLTvLive02 = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3086_82930)">
        <path
          d="M17.86 38.0474H28.2631"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.1523 10.3613H5.02155C4.15249 10.3613 3.44794 11.0658 3.44794 11.9349V26.6262"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.5521 26.5615V11.9349C42.5521 11.0658 41.8476 10.3613 40.9784 10.3613H35.7687"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23 28.959L16.195 21.6754C15.573 21.0097 14.5173 21.0097 13.8953 21.6754L9.33038 26.5613"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M39.5196 29.6117L32.1048 21.6755C31.4827 21.0096 30.427 21.0096 29.8051 21.6755L17.7369 34.592"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.9141 10.3613C26.9141 12.523 25.1617 14.2754 23 14.2754C20.8383 14.2754 19.0859 12.523 19.0859 10.3613C19.0859 8.19953 20.8383 6.44712 23 6.44712C25.1617 6.44712 26.9141 8.19953 26.9141 10.3613Z"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.6873 10.9802V9.74225C32.6873 9.58457 32.5896 9.44334 32.4421 9.38755L30.2 8.54104C30.0874 8.49854 30.0032 8.40474 29.9691 8.28947C29.8242 7.80126 29.6297 7.33444 29.3909 6.8951C29.3347 6.79151 29.328 6.66824 29.3765 6.56088L30.365 4.37301C30.43 4.22935 30.3992 4.06044 30.2877 3.94894L29.4122 3.0736C29.3007 2.96201 29.1318 2.93119 28.9882 2.99615L26.8003 3.9847C26.6929 4.03322 26.5697 4.02657 26.4661 3.97033C26.0267 3.73152 25.5599 3.53701 25.0717 3.39218C24.9564 3.35795 24.8626 3.27377 24.8201 3.16128L23.9736 0.919053C23.9179 0.771529 23.7767 0.67387 23.6189 0.67387H22.381C22.2233 0.67387 22.0821 0.771529 22.0264 0.919053L21.1799 3.16128C21.1374 3.27377 21.0435 3.35795 20.9282 3.39218C20.44 3.53701 19.9732 3.73152 19.5338 3.97033C19.4303 4.02657 19.307 4.03322 19.1996 3.9847L17.0118 2.99615C16.8681 2.93119 16.6992 2.96201 16.5877 3.0736L15.7123 3.94894C15.6008 4.06044 15.57 4.22935 15.6349 4.37301L16.6235 6.56088C16.672 6.66824 16.6653 6.79151 16.6091 6.8951C16.3703 7.33444 16.1757 7.80126 16.0309 8.28947C15.9967 8.40474 15.9126 8.49854 15.8 8.54104L13.5579 9.38755C13.4103 9.44334 13.3127 9.58457 13.3127 9.74225V10.9802C13.3127 11.1379 13.4103 11.2791 13.5579 11.3348L15.8 12.1814C15.9126 12.2239 15.9967 12.3177 16.0309 12.433C16.1757 12.9212 16.3703 13.388 16.6091 13.8274C16.6653 13.9309 16.672 14.0542 16.6235 14.1616L15.6349 16.3494C15.57 16.4931 15.6008 16.662 15.7123 16.7735L16.5877 17.6489C16.6992 17.7604 16.8681 17.7913 17.0118 17.7263L19.1996 16.7377C19.307 16.6891 19.4303 16.6959 19.5338 16.7521C19.9732 16.9908 20.44 17.1854 20.9282 17.3303C21.0435 17.3645 21.1374 17.4487 21.1799 17.5613L22.0264 19.8034C22.0821 19.9509 22.2233 20.0486 22.381 20.0486H23.6189C23.7767 20.0486 23.9179 19.9509 23.9736 19.8034L24.8201 17.5613C24.8626 17.4487 24.9564 17.3645 25.0717 17.3303C25.5599 17.1854 26.0267 16.9908 26.4661 16.7521C26.5697 16.6959 26.6929 16.6891 26.8003 16.7377L28.9882 17.7263C29.1318 17.7913 29.3007 17.7604 29.4122 17.6489L30.2877 16.7735C30.3992 16.662 30.43 16.4931 30.365 16.3494L29.3765 14.1616C29.328 14.0542 29.3347 13.9309 29.3909 13.8274C29.6297 13.388 29.8242 12.9212 29.9691 12.433C30.0032 12.3177 30.0874 12.2239 30.2 12.1814L32.4421 11.3348C32.5896 11.2791 32.6873 11.1379 32.6873 10.9802Z"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45.3262 33.2889V31.4087C45.3262 30.4163 44.5217 29.6118 43.5293 29.6118H30.0599C29.0675 29.6118 28.2631 30.4163 28.2631 31.4087V43.5293C28.2631 44.5217 29.0675 45.3262 30.0599 45.3262H43.5293C44.5217 45.3262 45.3262 44.5217 45.3262 43.5293V36.8575"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.4707 45.3262H15.9401C16.9325 45.3262 17.737 44.5217 17.737 43.5293V31.4087C17.737 30.4163 16.9325 29.6118 15.9401 29.6118H2.4707C1.47829 29.6118 0.673828 30.4163 0.673828 31.4087V43.5293C0.673828 44.5217 1.47829 45.3262 2.4707 45.3262Z"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34.2555 41.0817L40.019 37.8612C40.3257 37.6898 40.3257 37.2483 40.019 37.0769L34.2555 33.8566C33.9561 33.6892 33.5872 33.9057 33.5872 34.2487V40.6895C33.5872 41.0326 33.9561 41.249 34.2555 41.0817Z"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.51288 34.2268H13.898"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.51288 37.469H13.898"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.51288 40.7109H13.898"
          stroke="#457ABD"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3086_82930">
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HLTvLive02;
